import { ApolloClient, InMemoryCache } from '@apollo/client';
import {fragmentMatcher} from './fragmentMatcher';

const cache = new InMemoryCache({ fragmentMatcher });

export const GqlClient = new ApolloClient({
    cache,
    uri: window.siteUrl+"api",
});